<template>
	<div>
		<div class="wrap">
			<Title :title="vacationName">
				<div class="title-more" slot="title-more" v-if="voteList.length<1">
					<el-button type="warning" size="mini" @click="toAddSelection">开启投票</el-button>
				</div>
			</Title>
			<el-table border :data="voteList" style="width: 100%">
				<el-table-column prop="voteName" label="名称" height="30">
				</el-table-column>
				<el-table-column label="投票时间">
					<template slot-scope="scope">
						{{scope.row.startTime | datefmt2('MM-DD HH:mm:ss')}}至{{scope.row.endTime | datefmt2('MM-DD HH:mm:ss')}}
					</template>
				</el-table-column>
				<el-table-column label="投票数/参与人数">
					<template slot-scope="scope">
						{{scope.row.voteCount}}/{{scope.row.playerCount}}
					</template>
				</el-table-column>
				<el-table-column label="发布状态">
					<template slot-scope="scope">
						<span v-if="scope.row.status==0">草稿</span>
						<span v-if="scope.row.status==1">已完成待发布</span>
						<span v-if="scope.row.status==2">已发布</span>
					</template>
				</el-table-column>
				<el-table-column prop="publishTime" label="发布时间">
					<template slot-scope="scope">
						{{scope.row.publishTime | datefmt2('YYYY-MM-DD HH:mm:ss')}}
					</template>
				</el-table-column>
				<el-table-column prop="showFlag" label="启用状态">
					<template slot-scope="scope">
						<el-switch 
						@click.native.prevent="changeShowFlag(scope.row)" 
						v-model="scope.row.showFlag"
						disabled
						active-color="#13ce66"
						inactive-color="#ff4949">
						</el-switch>
					</template>
				</el-table-column>
				<el-table-column label="操作">
					<template slot-scope="scope">
						<el-dropdown>
							<span class="el-dropdown-link">
								...
							</span>
							<el-dropdown-menu slot="dropdown" class="dropdown-new">
								<el-dropdown-item @click.native="publishVote(scope)" v-if="scope.row.status=='0'" command="publish">发布</el-dropdown-item>
								<el-dropdown-item v-if="scope.row.status=='0'" @click.native="modifyVote(scope.row)">修改</el-dropdown-item>
								<el-dropdown-item @click.native="detailVote(scope.row)">详情</el-dropdown-item>
								<el-dropdown-item @click.native="deleteVote(scope)"
									command="delete">删除</el-dropdown-item>
								<el-dropdown-item command="list" @click.native="voteLog(scope.row)">投票记录</el-dropdown-item>
							</el-dropdown-menu>
						</el-dropdown>
					</template>
				</el-table-column>
			</el-table>
			<Pagination :total="total" @pageChange="handleCurrentChange"/>
		</div>
		<div class="wrap">
			<Title title="参选者详情"></Title>
			<el-table border :data="votePlayerList" style="width: 100%">
				<el-table-column prop="voteNo" label="投票号" height="30">
				</el-table-column>
				<el-table-column prop="playerName" label="姓名">
				</el-table-column>
				<el-table-column prop="schoolName" label="学校">
				</el-table-column>
				<el-table-column prop="voteCount" label="票数">
				</el-table-column>
			</el-table>
		</div>
	</div>
</template>

<script>
	import qs from 'qs'
	import { post,ajaxParam } from '@/units/request.js'
	import Title from '@/components/titleAdmin'
	import VoteListModel from '@/modules/vote/voteList.js'
	export default {
		name: 'ActivityVote',
		components: {
			Title
		},
		mixins: [
			VoteListModel
		],
		data() {
			return {
				voteId: '',
				votePlayerList: [],
				playPageNum: 1,
				playPageSize: 10,
				playTotal: 0
			}
		},
		created(){
			setTimeout(res=>{
				this.getVotePlayerList()
			},500)
		},
		methods: {
			toAddSelection(item){
				this.$router.push({
					path: '/admin/addSelection?vacationId='+this.vacationId
				})
			},
			//获取参选者列表
			async getVotePlayerList() {
				console.log(']]]]')
				console.log(this.voteList)
				if(this.voteList.length>0) {
					this.voteId = this.voteList[0].id
				}
				let param = {
					voteId: this.voteId,
					pageNum: this.playPageNum,
					pageSize: this.playPageSize
				}
				ajaxParam(param)
				const res = await post('admin/voteInfo/votePlayerList', qs.stringify(param))
				if (res.data.code == 200) {
					let datalist = res.data.page.items
					this.votePlayerList = datalist
					this.playTotal = res.data.page.count
				}
			}
		}
	}
</script>

<style scoped lang="less">
	.wrap /deep/ .el-table .el-table__cell {
		padding: 6px 0 !important;
		font-size: 12px;
	}

	.wrap {
		background: #fff;
		border: 1px solid #e4e4e4;
		border-radius: 4px;
		margin-bottom: 10px;
		padding: 10px;
	}
	.title /deep/ .el-button--warning{
		background-color: #EB6B1B
	}
	.title /deep/ .el-button--mini{
		padding: 4px 10px;
	}
	.dropdown-new {
		li {
			height: 26px;
			line-height: 26px;
			font-size: 12px;
			color: #EB6B1B;
		}
	
		li:hover {
			background: none;
			text-decoration: underline;
			color: #EB6B1B;
		}
	}
	/deep/ .el-dropdown {
		color: #EB6B1B;
	}
	/deep/ .el-switch.is-disabled {
	 opacity: 1;
	}
	/deep/ .el-switch.is-disabled .el-switch__core, /deep/ .el-switch.is-disabled .el-switch__label {
	  cursor: pointer !important;;
	}
</style>